import { serverResponse } from 'app'

import * as actions from '../../actions/permissions'

export const getPermissionsInitialState = () =>
  serverResponse({
    search: serverResponse(),
  })

export default (state = getPermissionsInitialState(), action = {}) => {
  switch (action.type) {
    case actions.TRN_PERMISSIONS_FETCH: {
      return {
        ...state,
        loaded: false,
        loading: true,
      }
    }

    case actions.TRN_PERMISSIONS_FETCH_CANCELED: {
      return {
        ...state,
        ...action.payload,
        loaded: false,
        loading: false,
      }
    }
    case actions.TRN_PERMISSIONS_FETCH_ERROR: {
      return {
        ...state,
        ...action.payload,
        loaded: true,
        loading: false,
      }
    }
    case actions.TRN_PERMISSIONS_FETCH_FULFILLED: {
      return {
        ...state,
        ...action.payload,
        loaded: true,
        loading: false,
      }
    }
    case actions.TRN_PERMISSIONS_RESET: {
      return getPermissionsInitialState()
    }

    case actions.TRN_PERMISSIONS_SEARCH_FETCH: {
      return {
        ...state,
        search: {
          ...state.search,
          loaded: false,
          loading: true,
        },
      }
    }
    case actions.TRN_PERMISSIONS_SEARCH_FETCH_CANCELED: {
      return {
        ...state,
        search: {
          ...state.search,
          loaded: false,
          loading: false,
        },
      }
    }
    case actions.TRN_PERMISSIONS_SEARCH_FETCH_ERROR: {
      return {
        ...state,
        search: {
          ...state.search,
          ...action.payload,
          loaded: true,
          loading: false,
        },
      }
    }
    case actions.TRN_PERMISSIONS_SEARCH_FETCH_FULFILLED: {
      return {
        ...state,
        search: {
          ...state.search,
          ...action.payload,
          loaded: true,
          loading: false,
        },
      }
    }

    case actions.TRN_PERMISSIONS_SET_FETCH: {
      return {
        ...state,
        data: state.data.map((auth) => ({
          ...auth,
          level: action.payload.level,
          levelOrig: auth.level,
          loading: auth.user.id === action.payload.userId,
        })),
      }
    }
    case actions.TRN_PERMISSIONS_SET_FETCH_CANCELED: {
      return {
        ...state,
        data: state.data.map((auth) => ({
          ...auth,
          level: auth.levelOrig || auth.level,
          levelOrig: null,
          loading: false,
        })),
      }
    }
    case actions.TRN_PERMISSIONS_SET_FETCH_ERROR: {
      return {
        ...state,
        ...action.payload,
        data: state.data.map((auth) => ({
          ...auth,
          level: auth.levelOrig || auth.level,
          levelOrig: null,
          loading: false,
        })),
      }
    }
    case actions.TRN_PERMISSIONS_SET_FETCH_FULFILLED: {
      const data = state.data.map((auth) => ({
        ...auth,
        ...action.payload.data.find((auth2) => auth2.id === auth.id),
        levelOrig: null,
        loading: false,
      }))

      action.payload.data.forEach((newAuth) => {
        if (!data.some((auth) => auth.id === newAuth.id)) {
          data.unshift(newAuth)
        }
      })

      return {
        ...state,
        data,
      }
    }

    case actions.TRN_PERMISSIONS_TOGGLE_FETCH: {
      return {
        ...state,
        data: state.data.map((auth) => ({
          ...auth,
          loading: auth.id === action.payload.authId,
        })),
      }
    }
    case actions.TRN_PERMISSIONS_TOGGLE_FETCH_CANCELED: {
      return {
        ...state,
        data: state.data.map((auth) => ({
          ...auth,
          loading: false,
        })),
      }
    }
    case actions.TRN_PERMISSIONS_TOGGLE_FETCH_ERROR: {
      return {
        ...state,
        ...action.payload,
        data: state.data.map((auth) => ({
          ...auth,
          loading: false,
        })),
      }
    }
    case actions.TRN_PERMISSIONS_TOGGLE_FETCH_FULFILLED: {
      return {
        ...state,
        data: state.data.map((auth) => ({
          ...auth,
          ...action.payload.data.find((auth2) => auth2.id === auth.id),
          loading: false,
        })),
      }
    }
    default:
  }
  return state
}
